import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";
import { useApiClient } from "@/hooks/useApiClient";
import type { RequestedPicturesHistoryItem } from "../types";

/**
 * 指定したland_idの登記取得履歴を取得する
 */
export const useRequestedPicturesHistory = (): SWRMutationResponse<
  RequestedPicturesHistoryItem,
  Error,
  string,
  number
> => {
  const { apiClient } = useApiClient();

  const fetcher = async (
    _key: string,
    { arg }: { arg: number }
  ): Promise<RequestedPicturesHistoryItem> => {
    const response = await apiClient.get<RequestedPicturesHistoryItem>(
      `/map/requested-pictures/${arg}`
    );
    return response.data;
  };

  return useSWRMutation("/map/requested-pictures", fetcher, {
    revalidate: false,
  });
};
